import axios from "axios";
import { API_URL } from "../config/apiConfig";

const toLocalDateString = (value) => {
    if (!value) return value;
    if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
};

export const getCapWeek = async ({ date, weekStart, affiliateId } = {}) => {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API_URL}/cap/week`, {
        params: {
            ...(date ? { date } : {}),
            ...(weekStart ? { weekStart: toLocalDateString(weekStart) } : {}),
            ...(affiliateId ? { affiliateId } : {}),
        },
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
    });
    return response.data;
};

export const getCapWeeks = async () => {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API_URL}/cap/weeks`, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
    });
    return response.data;
};

export const uploadCapWeek = async (affiliateFile, classPlanFile, competeFile = null) => {
    const token = localStorage.getItem("token");
    const formData = new FormData();
    formData.append("affiliateFile", affiliateFile);
    formData.append("classPlanFile", classPlanFile);
    if (competeFile) {
        formData.append("competeFile", competeFile);
    }

    const response = await axios.post(`${API_URL}/cap/upload`, formData, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
        },
    });
    return response.data;
};

export const getCapApplyStatistics = async ({ startDate, endDate } = {}) => {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API_URL}/cap/apply-statistics`, {
        params: {
            ...(startDate ? { startDate } : {}),
            ...(endDate ? { endDate } : {}),
        },
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
    });
    return response.data;
};

export const getCapAvailability = async () => {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API_URL}/cap/availability`, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
    });
    return response.data;
};

export const applyCapTrack = async ({ affiliateId, weekStart, dayName, sectionKey, targetDate }) => {
    const token = localStorage.getItem("token");
    const response = await axios.post(
        `${API_URL}/cap/apply-track`,
        {
            affiliateId,
            weekStart: toLocalDateString(weekStart),
            dayName,
            sectionKey,
            ...(targetDate ? { targetDate: toLocalDateString(targetDate) } : {}),
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        }
    );
    return response.data;
};

export const applyCapDayAll = async ({ affiliateId, weekStart, dayName, targetDate }) => {
    const token = localStorage.getItem("token");
    const response = await axios.post(
        `${API_URL}/cap/apply-day-all`,
        {
            affiliateId,
            weekStart: toLocalDateString(weekStart),
            dayName,
            ...(targetDate ? { targetDate: toLocalDateString(targetDate) } : {}),
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        }
    );
    return response.data;
};

export const applyWorkYourWeakness = async ({ affiliateId, weekStart }) => {
    const token = localStorage.getItem("token");
    const response = await axios.post(
        `${API_URL}/cap/apply-work-your-weakness`,
        { affiliateId, weekStart: toLocalDateString(weekStart) },
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        }
    );
    return response.data;
};

export const getAppliedWorkYourWeakness = async ({ affiliateId, weekStart }) => {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API_URL}/cap/work-your-weakness`, {
        params: { affiliateId, weekStart: toLocalDateString(weekStart) },
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
    });
    return response.data;
};

export const updateAppliedWorkYourWeakness = async ({ id, content }) => {
    const token = localStorage.getItem("token");
    const response = await axios.put(
        `${API_URL}/cap/work-your-weakness/${id}`,
        { content },
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        }
    );
    return response.data;
};

export const upsertAppliedWorkYourWeakness = async ({ affiliateId, weekStart, content }) => {
    const token = localStorage.getItem("token");
    const response = await axios.post(
        `${API_URL}/cap/work-your-weakness`,
        { affiliateId, weekStart: toLocalDateString(weekStart), content },
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        }
    );
    return response.data;
};
